import { render, staticRenderFns } from "./CourseVideoSeting.vue?vue&type=template&id=7c0de4d6&scoped=true"
import script from "./CourseVideoSeting.vue?vue&type=script&lang=js"
export * from "./CourseVideoSeting.vue?vue&type=script&lang=js"
import style0 from "./CourseVideoSeting.vue?vue&type=style&index=0&id=7c0de4d6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0de4d6",
  null
  
)

export default component.exports